(ns app.front.view.admin.migration.activate-existing-addresses
  (:require [app.front.view.admin.migration.template :as admin-migration-template]
            [core.front.event :refer [>evt]]))

(defn view [match]
  [admin-migration-template/admin-page-for-migration
   {:task-id   :app.admin.migration.task/activate-existing-addresses
    :title     "Set existing addresses active"
    :help-text (str "This migration sets addresses that do not yet have a state to the active state. "
                    "Addresses that are already active or unverified are left untouched.\n"
                    "If the migration fails, resolve the reported error and run it again to process remaining "
                    "addresses.")}
   match])

(def route
  {:name        :view/admin.migration.activate-existing-addresses
   :view        view
   :controllers [{:start (fn [_]
                           (>evt [::admin-migration-template/fetch-migration-tasks
                                  :app.admin.migration.task/activate-existing-addresses]))}]})
